import { FC, useState } from 'react';

import { ConnectCapitalFinancing, ConnectCapitalFinancingPromotion } from '@stripe/react-connect-js';
import { Loader } from 'components';

interface CapitalComponentsProps {
  reloadCapital: () => void;
  refreshKey: number;
}

const CapitalComponents: FC<CapitalComponentsProps> = ({ reloadCapital, refreshKey }) => {
  const [isLoadingFinancings, setIsLoadingFinancings] = useState(true);
  const [hasLoadingStarted, setHasLoadingStarted] = useState(false);

  const onFinancingsLoaded = () => {
    setIsLoadingFinancings(false);
  };

  const onLoaderStart = () => {
    setHasLoadingStarted(true);
  };

  return (
    <>
      <div className="space-y-8">
        <div id="capital-financing-promotion-container">
          <ConnectCapitalFinancingPromotion
            layout="full"
            onApplicationSubmitted={reloadCapital}
            key={refreshKey}
            onEligibleFinancingOfferLoaded={onFinancingsLoaded}
            onLoaderStart={onLoaderStart}
          />
        </div>
        <div id="capital-financing-container">
          <ConnectCapitalFinancing onLoaderStart={onLoaderStart} />
        </div>
      </div>
      {isLoadingFinancings && (
        <div className="flex w-full flex-col items-center justify-center">
          {!hasLoadingStarted && <Loader />}
          <div className="text-center text-sbase text-primaryText">
            You are important to us, fetching the best possible offers for you
          </div>
        </div>
      )}
    </>
  );
};

export default CapitalComponents;
